import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { I18n, Translate } from 'react-redux-i18n';
import { withRouterV6 } from '../../helpers/withRouterV6.jsx';

import * as fundraiserActions from './reducer';
import * as campaignActions from '../campaign/store/campaignActions';
import {
  getMarkSpamModalConfigForRow,
  getPageIdForRow,
  normalizeRowAsSpamEntity
} from '../fundraiser/markSpamRowHelpers';
import { setRedirectUrl } from '../../modules/session';
import { hideCondition } from '../../helpers/hideHelper';
import clear from '../../components/clear';
import { Record } from '../../modules/bin/utility';
import CapitalizeText from '../../components/common/capitalizeText';
import get from 'lodash.get';

import { Common } from '../../components';
import BasePage from '../../components/common/basePageView';
import ContextMenu from '../../components/common/grid/contextMenu';
import MarkSpamModal from '../../components/common/MarkSpamModal';
import { Table, Menu } from 'semantic-ui-react';
import Spinner from '../../components/common/spinner';

import { gridKeys } from '../../constants/gridKeys';
import { CONTEXT_MENU_KEYS } from '../../constants/contextMenuEntries';
import { pageTypesStrings, superteam } from '../../constants/pageTypes';
import {
  privacyStrings,
  PRIVACY_COLUMN,
  TYPE_COLUMN
} from '../campaign/constants';
import { i18nKeys } from './constants';
import { fundraisersBaseOptions } from './metadataConstants';
import { RootState } from '../../store';
import { ExportDataButton } from '../../components/template/templateExportButton';
import { ExportDownloadProvider } from '../export-history';
import { getListWithOrgFilter } from '../../helpers/listHelper';
import { withPageTitle } from '../../hocs';
import GridNavigationHelper from '../../helpers/GridNavigationHelper';
import { renderFranchiseAwareNameColumn } from '../../helpers/franchiseNameFormatter';

class FundraiserPage extends Component<any, { selectedSpamRow: any }> {
  state = { selectedSpamRow: null as any };

  componentDidMount() {
    // Clear any stored return URL when entering this grid
    GridNavigationHelper.clearReturnUrlOnGridEntry();
  }

  hideMarkSpamContextMenuItem = (item: any) => {
    return !this.props.isSystemAdmin || !!item?.isSpam;
  };

  onMarkSpamContextClick = (_id: any, item: any) => {
    this.setState({ selectedSpamRow: normalizeRowAsSpamEntity(item) });
    this.props.campaignActions.showMarkSpamConfirmation();
  };

  renderMarkSpamModal = () => {
    const row = this.state.selectedSpamRow;
    const { pageType, getRecord, translationBase } = getMarkSpamModalConfigForRow(row);
    return (
      <MarkSpamModal
        entityId={getPageIdForRow(row) as number}
        entity={row}
        stateSliceKey="campaign"
        markAsSpam={(id: number) => campaignActions.markPageAsSpam(pageType, id)}
        hideConfirmation={campaignActions.hideMarkSpamConfirmation}
        getRecord={getRecord}
        translationBase={translationBase}
      />
    );
  };

  hideColumnCondition = (item: any) => {
    return hideCondition(
      this.props.isOrganizationAdmin,
      item,
      'path',
      'organization.name'
    );
  };

  isFundraisersContextMenuItemHidden = (item: any) => {
    return item.type === pageTypesStrings.FUNDRAISER;
  };

  isDonationsContextMenuItemHidden = () => {
    return this.props.isEventAdmin;
  };

  onToggleColumnsChange = (toggleColumns: any) => {
    this.props.toggleColumnsChange(toggleColumns);
  };

  isChooseTabButtonDisabled = () => {
    return (
      Record.isRecordLoading(this.props.list) ||
      Record.isRecordLoading(this.props.list.metadata)
    );
  };

  getPanel = () => {
    const { Panel } = Common.Grid.Managed as any;
    return (
      <Panel name="right">
        <ExportDownloadProvider entity="page" version="v3">
          {({ open }) => (
            <ExportDataButton
              featureFlag
              versions={['v2', 'v3']}
              onExportClick={(version) => {
                if (version === 'v3') {
                  open({
                    layout: 'Extended',
                    ...(this.props.list?.request || {})
                  });
                } else {
                  open(this.props.list?.request);
                }
              }}
            />
          )}
        </ExportDownloadProvider>
      </Panel>
    );
  };
  getContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_FUNDRAISER.key}
          label={I18n.t('fundraiser.list.context.view-fundraiser')}
          contextMenuOptions={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_FUNDRAISER}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.FUNDRAISERS.EDIT_PAGE.key}
          label={I18n.t('fundraiser.list.context.edit-page')}
          contextMenuOptions={CONTEXT_MENU_KEYS.FUNDRAISERS.EDIT_PAGE}
          onClick={GridNavigationHelper.createEditClickHandler(
            this.props.setRedirectUrl,
            this.props.location
          )}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_PUBLIC.key}
          label={I18n.t('fundraiser.list.context.view-public-page')}
          contextMenuOptions={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_PUBLIC}
        // isHiden={this.isViewContextMenuItemHidden}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_DONATIONS.key}
          label={I18n.t('fundraiser.list.context.view-page-donations')}
          contextMenuOptions={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_DONATIONS}
          isHiden={this.isDonationsContextMenuItemHidden}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_FUNDRAISERS.key}
          label={I18n.t('fundraiser.list.context.view-page-fundraisers')}
          isHiden={this.isFundraisersContextMenuItemHidden}
          contextMenuOptions={CONTEXT_MENU_KEYS.FUNDRAISERS.VIEW_FUNDRAISERS}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.FUNDRAISERS.MARK_AS_SPAM.key}
          label={I18n.t('fundraiser.list.context.mark-as-spam')}
          contextMenuOptions={CONTEXT_MENU_KEYS.FUNDRAISERS.MARK_AS_SPAM}
          onClick={this.onMarkSpamContextClick}
          isHiden={this.hideMarkSpamContextMenuItem}
          systemOnly
        />
      </ContextMenu>
    );
  };

  // Cached franchise-aware renderer for the campaign.name column. Rebuilt only
  // when `isSystemAdmin` changes (it arrives asynchronously from the session
  // slice on app boot) rather than per cell, avoiding a fresh closure
  // allocation for every row in the grid.
  _franchiseRenderer?: ReturnType<typeof renderFranchiseAwareNameColumn>;
  _franchiseRendererAdmin?: boolean;
  getFranchiseRenderer = () => {
    if (
      !this._franchiseRenderer ||
      this._franchiseRendererAdmin !== this.props.isSystemAdmin
    ) {
      this._franchiseRendererAdmin = this.props.isSystemAdmin;
      this._franchiseRenderer = renderFranchiseAwareNameColumn(
        this.props.isSystemAdmin,
        {
          name: 'campaign.name',
          franchise: 'franchise',
          franchiseEdition: 'franchiseEdition',
          franchiseEditionYear: 'franchiseEditionYear',
        },
        'campaign.name'
      );
    }
    return this._franchiseRenderer;
  };

  // Each row carries `franchise` / `franchiseEdition` at the top level,
  // referring to the page's owning campaign.
  columnRender = (column: any, value: any, item: any) => {
    const franchiseCell = this.getFranchiseRenderer()(column, value, item);
    if (franchiseCell) return franchiseCell;

    if (column.id === PRIVACY_COLUMN) {
      const text =
        value === true ? privacyStrings.PUBLIC : privacyStrings.PRIVATE;
      return <Table.Cell>{text}</Table.Cell>;
    } else if (column.id === TYPE_COLUMN) {
      return (
        <Table.Cell>
          <CapitalizeText>
            {value === pageTypesStrings.COLLECTION ? superteam : value}
          </CapitalizeText>
        </Table.Cell>
      );
    }
  };

  render() {
    if (Record.isRecordLoading(this.props.exportFileRecord)) {
      return <Spinner />;
    }

    const panel = this.getPanel();
    const contextMenu = this.getContextMenu();
    const filterButtons = get(this.props, 'list.filterButtons');
    return (
      <BasePage>
        <h1>
          <Translate value={i18nKeys.PAGE_TITLE} />
        </h1>
        {!this.props.isEventAdmin && (
          <Menu
            className="accounts-tab-buttons-group"
            style={{ margin: '0px', borderRight: '0px' }}
          >
            {Object.keys(filterButtons).map((key) => {
              const item = filterButtons[key];
              return (
                <Menu.Item
                  key={item.key}
                  name={item.key}
                  content={I18n.t(item.I18nKey)}
                  active={item.key === this.props.match.params.tab}
                  disabled={this.isChooseTabButtonDisabled()}
                  onClick={() => {
                    this.props.history.push(`/fundraisers/${item.key}`);
                  }}
                />
              );
            })}
          </Menu>
        )}

        <Common.Grid.Managed
          listKey={gridKeys.FUNDRAISERS}
          list={this.props.list}
          actions={this.props.listActions}
          search
          advancedFilterButton
          searchVersion="v3"
          toggleColumns
          filtersButton
          activeTabFilter={this.props.match.params.tab}
          hideColumn={this.hideColumnCondition}
          baseOptions={fundraisersBaseOptions}
          columnRender={this.columnRender}
        >
          {panel}
          {contextMenu}
        </Common.Grid.Managed>
        {this.renderMarkSpamModal()}
      </BasePage>
    );
  }
}

const mapState = ({ fundraiser, session }: RootState) => {
  const exportFileRecord = fundraiser.exportFileRecord;
  const isSystemAdmin = get(session, 'isSystemAdmin');
  if (fundraiser?.fundraisersList?.availableFiltersKeys) {
    fundraiser.fundraisersList.availableFiltersKeys = getListWithOrgFilter(fundraiser.fundraisersList.availableFiltersKeys, isSystemAdmin);
  }

  const fundraiserGrid = (Common.Grid.Managed as any).mapGridState(
    fundraiser,
    gridKeys.FUNDRAISERS
  );

  const isOrganizationAdmin = get(session, 'isOrganizationAdmin');
  const isEventAdmin = get(session, 'isEventAdmin');

  return {
    exportFileRecord,
    list: fundraiserGrid.list,
    listKey: fundraiserGrid.listKey,
    isOrganizationAdmin,
    isEventAdmin,
    isSystemAdmin
  };
};

const mapDispatch = (dispatch: Dispatch<any>) => {
  var actions = {
    getMetadata: fundraiserActions.getMetadata,
    getListData: fundraiserActions.getListData,
    getListDataBySearchTerm: fundraiserActions.getListDataBySearchTerm,
    toggleColumnsChange: fundraiserActions.toggleColumnsChange
  };

  const listActions = (Common.Grid.Managed as any).bindGridActions(
    dispatch,
    actions
  );

  return {
    listActions,
    fundraiserActions: bindActionCreators(fundraiserActions as any, dispatch),
    campaignActions: bindActionCreators(
      { showMarkSpamConfirmation: campaignActions.showMarkSpamConfirmation },
      dispatch
    ),
    setRedirectUrl: bindActionCreators(setRedirectUrl, dispatch)
  };
};

const titleResolver = (props: any) => {
  const tab = get(props, 'match.params.tab', 'all');
  const capitalizedTab = tab.charAt(0).toUpperCase() + tab.slice(1);
  return I18n.t('page-titles.fundraisers.list', { tab: capitalizedTab });
};

const FundraiserPageContainer = withRouterV6(clear(
  connect(mapState, mapDispatch)(withPageTitle(titleResolver)(FundraiserPage))
));
export default FundraiserPageContainer;
